export const heroStats = [
  { label: '官方公告', value: '186', unit: '条' },
  { label: '正式声明', value: '32', unit: '篇' },
  { label: '消息动态', value: '1.2w+', unit: '条' },
  { label: '长期在线', value: '365', unit: '天' },
];

export const tickerItems = [
  '吃瓜官网 2026 秋季服务规范更新已正式发布',
  '关于近期个别账号冒充官方账号的郑重声明',
  '消息中心 9 月例行系统维护安排通知',
  '吃瓜官网创作者扶持计划第二期开启报名',
  '平台《内容发布公约》2.0 版本全量上线',
  '9 月 15 日 02:00-05:00 数据库升级维护',
];

export const featuredAnnouncement = {
  tag: '重点公告',
  title: '吃瓜官网《平台内容发布与用户服务公约》2026 秋季版正式施行',
  date: '2026-09-05',
  time: '10:20',
  readTime: '阅读约 6 分钟',
  summary:
    '为进一步规范官方信息发布秩序、保障广大网友的知情权与使用体验，吃瓜官网现发布最新版平台公约。本次更新重点完善了官方消息的发布流程、公告分级披露机制与用户反馈通道，自发布次日起全面生效，敬请广大网友查阅与监督。',
  highlights: ['官方消息分级披露机制全面上线', '用户反馈与申诉通道统一整合', '历史公告归档可随时一键检索'],
};

export const announcementList = [
  { id: 'a1', tag: '平台公告', type: 'primary', date: '09-07', title: '关于吃瓜官网「消息中心」视觉与交互体验升级的通知' },
  { id: 'a2', tag: '功能更新', type: 'accent', date: '09-04', title: '官方动态支持分类订阅，重要通知不再错过' },
  { id: 'a3', tag: '系统维护', type: 'secondary', date: '09-01', title: '9 月 12 日 02:00-06:00 系统例行维护公告' },
  { id: 'a4', tag: '活动通知', type: 'accent', date: '08-28', title: '「老粉召回」计划上线，新版本内容抢先看' },
  { id: 'a5', tag: '安全提醒', type: 'secondary', date: '08-25', title: '警惕冒充官方客服的诈骗行为与钓鱼链接' },
];

export const statements = [
  {
    id: 's1',
    category: '郑重声明',
    tone: '严肃',
    date: '2026-09-03',
    title: '关于「吃瓜官网内部消息外泄」不实传闻的郑重声明',
    body: '近日网络流传所谓“吃瓜官网内部消息提前泄露”等说法，均属不实信息。吃瓜官网所有官方消息仅通过本网站及经认证的官方渠道发布，任何未经确认的“内部截图”请勿轻信与传播。',
  },
  {
    id: 's2',
    category: '辟谣说明',
    tone: '紧急',
    date: '2026-08-30',
    title: '辟谣：网传“吃瓜官网即将停运”系谣言',
    body: '针对近期个别自媒体散布的“吃瓜官网将停止运营”消息，特此澄清：平台一切运营正常，官方消息更新从未中断，请以本官网通知为准，勿传谣勿信谣。',
  },
  {
    id: 's3',
    category: '合规说明',
    tone: '一般',
    date: '2026-08-19',
    title: '关于第三方工具接入数据接口的合规使用说明',
    body: '为保障数据安全与公平使用，未经官方授权的第三方工具不得擅自抓取或搬运本网站官方内容。相关开放合作需依据开发者平台规范提交申请，违规者将被依法处理。',
  },
  {
    id: 's4',
    category: '维权声明',
    tone: '严肃',
    date: '2026-08-02',
    title: '严正声明：坚决打击冒用吃瓜官网名义从事的侵权行为',
    body: '近期出现多起冒用“吃瓜官网”名称、标识开展商业推广的行为。吃瓜官网将保留追究法律责任的权利，欢迎广大网友通过官方渠道举报违规线索。',
  },
];

export const dynamicList = [
  { id: 'd1', chip: '官方动态', tone: 'primary', time: '今天 09:12', text: '《秋季版平台公约》正式施行，历史公告区同步完成归档与检索优化。' },
  { id: 'd2', chip: '新增功能', tone: 'accent', time: '昨天 18:40', text: '官网公告列表新增「置顶重点」标识，热门官方消息更醒目易读。' },
  { id: 'd3', chip: '通知', tone: 'secondary', time: '昨天 11:05', text: '消息中心支持按公告分类关注，重要更新将优先推送提醒。' },
  { id: 'd4', chip: '维护', tone: 'secondary', time: '09-04 22:00', text: '站点安全证书与加速节点完成例行升级，访问稳定性提升。' },
  { id: 'd5', chip: '官方动态', tone: 'primary', time: '09-03 15:30', text: '吃瓜官网「创作者扶持计划」第二期报名通道已开放。' },
  { id: 'd6', chip: '通知', tone: 'secondary', time: '09-01 09:00', text: '《内容发布公约 2.0》正式上线，规范条款已可全文查阅。' },
  { id: 'd7', chip: '新增功能', tone: 'accent', time: '08-26 16:20', text: '公告详情页新增「要点速览」卡片，长公告阅读更高效。' },
];

export type FeatureCard = {
  img: string;
  tag: string;
  tone: 'primary' | 'accent' | 'secondary';
  title: string;
  desc: string;
  views: string;
  date: string;
};

export const featureCards: FeatureCard[] = [
  {
    img: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20a%20giant%20megaphone%20broadcasting%20colorful%20news%20waves%20and%20glowing%20light%20rings%20bursting%20outward%2C%20floating%20notification%20cards%20drifting%20around%2C%20warm%20vermilion%20red%20cream%20and%20fresh%20watermelon%20green%20palette%2C%20smooth%20soft%20pastel%20gradient%20background%2C%20dynamic%20energetic%20composition%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=660&seq=feature-annual-2026&orientation=landscape',
    tag: '年度盘点', tone: 'primary', title: '吃瓜官网 2026 半年度官方内容全景回顾', desc: '过去半年，官方公告累计发布 180+ 条、重大声明 32 篇，一起回顾那些被广泛关注的官方瞬间。', views: '12.8w', date: '09-06',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20a%20glowing%20crown%20and%20rising%20light%20rays%20above%20floating%20creation%20cards%20and%20stars%2C%20warm%20cream%20and%20fresh%20watermelon%20green%20palette%20with%20vermilion%20accents%2C%20soft%20pastel%20gradient%20background%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=660&seq=feature-creator-2026&orientation=landscape',
    tag: '扶持计划', tone: 'accent', title: '创作者扶持计划第二期启动，流量与激励加码', desc: '面向优质内容创作者开放扶持通道，提供官方流量扶持、专属曝光与创作激励支持。', views: '8.4w', date: '09-03',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20an%20open%20book%20and%20floating%20rule%20pages%20with%20shield%20and%20checkmark%20seals%2C%20warm%20vermilion%20cream%20and%20watermelon%20green%20palette%2C%20soft%20pastel%20gradient%20background%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=660&seq=feature-convention-2026&orientation=landscape',
    tag: '公约解读', tone: 'secondary', title: '一图读懂《内容发布公约 2.0》核心条款变化', desc: '新增信息披露分级与反馈通道条款，用最直观的方式带你快速掌握更新要点。', views: '6.1w', date: '09-01',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20a%20shiny%20security%20shield%20with%20lock%20surrounded%20by%20floating%20data%20blocks%20and%20privacy%20dots%2C%20warm%20watermelon%20green%20cream%20and%20vermilion%20palette%2C%20soft%20pastel%20gradient%20background%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=660&seq=feature-security-2026&orientation=landscape',
    tag: '数据安全', tone: 'accent', title: '2026 吃瓜官网数据安全与隐私保护白皮书', desc: '透明呈现平台在账号安全、数据加密与隐私保护上的一系列落地举措与成果。', views: '9.7w', date: '08-28',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20a%20large%20question%20mark%20next%20to%20floating%20answer%20cards%20and%20magnifying%20glass%20over%20glowing%20documents%2C%20warm%20cream%20vermilion%20and%20watermelon%20green%20palette%2C%20soft%20pastel%20gradient%20background%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=660&seq=feature-faq-2026&orientation=landscape',
    tag: '使用指南', tone: 'secondary', title: '新版消息中心上手指南：公告订阅与置顶玩法', desc: '手把手教你用好订阅与置顶功能，重要官方消息一条都不错过。', views: '5.2w', date: '08-24',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=vibrant%20editorial%203D%20illustration%20of%20a%20festive%20party%20scene%20with%20balloons%2C%20confetti%20and%20a%20sparkling%20gift%20box%20with%20floating%20news%20cards%2C%20warm%20vermilion%20cream%20and%20watermelon%20green%20palette%2C%20soft%20pastel%20gradient%20background%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=900&height=660&seq=feature-brand-2026&orientation=landscape',
    tag: '品牌活动', tone: 'primary', title: '「吃瓜周年庆」官方系列内容与福利活动回顾', desc: '周年庆期间官方动态密集发布，福利活动、联合内容与重磅彩蛋一网打尽。', views: '15.3w', date: '08-18',
  },
];

export const channels = [
  { icon: 'ri-smartphone-line', title: '官方 App 下载', desc: '消息实时推送,随时随地看官方动态', tone: 'primary' },
  { icon: 'ri-customer-service-2-line', title: '在线客服', desc: '官方客服在线答疑,工作日 9:00-21:00', tone: 'accent' },
  { icon: 'ri-feedback-line', title: '意见反馈', desc: '把你的建议告诉我们,一起把官网做得更好', tone: 'secondary' },
  { icon: 'ri-team-line', title: '商务合作', desc: '官方合作与品牌联名,欢迎联系洽谈', tone: 'accent' },
  { icon: 'ri-code-box-line', title: '开发者开放平台', desc: '接口接入与数据开放,共创更多玩法', tone: 'secondary' },
  { icon: 'ri-shield-check-line', title: '防骗与安全指南', desc: '识别冒充与钓鱼,保护账号与隐私安全', tone: 'primary' },
];

export const faqs = [
  { q: '吃瓜官网的官方消息通过哪些渠道发布？', a: '吃瓜官网的全部官方公告、声明与通知均以本官网为第一发布源，同步覆盖经实名认证的官方账号。凡未经上述渠道确认的消息，请勿轻信与扩散。' },
  { q: '如何第一时间收到最新公告与动态提醒？', a: '你可在消息中心开启「订阅提醒」，按平台公告、功能更新、系统维护等分类关注，重要官方消息将优先推送提醒，避免错过关键通知。' },
  { q: '官方声明与普通公告有什么区别？', a: '官方声明主要用于回应不实传闻、说明合规事项或表达立场，具有较高权威性；普通公告多用于发布功能更新、活动与例行通知，二者均以官网为准。' },
  { q: '看到疑似冒充官方的账号或链接怎么办？', a: '请勿点击任何来源不明的链接或转账。可将相关信息通过意见反馈通道提交给官方核实，平台会对违规账号依法处置并及时发布声明。' },
  { q: '历史公告与声明可以检索查阅吗？', a: '可以。官网设有历史归档区,支持按发布时间与分类筛选,过往官方内容均可随时检索与回看。' },
  { q: '想转载或引用官网内容需要怎么做？', a: '个人学习交流可合理引用并注明出处;商业使用或大范围转载需遵循合规说明并通过商务合作渠道申请授权。' },
];

export const footerNote =
  '吃瓜官网聚合平台最新官方公告、正式声明与消息动态,是广大网友第一时间了解吃瓜官网通知、掌握吃瓜官网官方消息与动态的一站式权威入口。本站内容仅供参考,一切以官方正式发布为准。';